// AUTO-GENERATED, do not edit
// It's a TypeScript wrapper for a NftCollection contract in Tolk.
/* eslint-disable */
import * as c from '@ton/core';
import { beginCell } from '@ton/core';
function makeCellFrom(self, storeFn_T) {
    let b = beginCell();
    storeFn_T(self, b);
    return b.endCell();
}
function loadAndCheckPrefix32(s, expected, structName) {
    let prefix = s.loadUint(32);
    if (prefix !== expected) {
        throw new Error(`Incorrect prefix for '${structName}': expected 0x${expected.toString(16).padStart(8, '0')}, got 0x${prefix.toString(16).padStart(8, '0')}`);
    }
}
function formatPrefix(prefixNum, prefixLen) {
    return prefixLen % 4 ? `0b${prefixNum.toString(2).padStart(prefixLen, '0')}` : `0x${prefixNum.toString(16).padStart(prefixLen / 4, '0')}`;
}
function loadAndCheckPrefix(s, expected, prefixLen, structName) {
    let prefix = s.loadUint(prefixLen);
    if (prefix !== expected) {
        throw new Error(`Incorrect prefix for '${structName}': expected ${formatPrefix(expected, prefixLen)}, got ${formatPrefix(prefix, prefixLen)}`);
    }
}
function lookupPrefix(s, expected, prefixLen) {
    return s.remainingBits >= prefixLen && s.preloadUint(prefixLen) === expected;
}
function throwNonePrefixMatch(fieldPath) {
    throw new Error(`Incorrect prefix for '${fieldPath}': none of variants matched`);
}
function storeCellRef(cell, b, storeFn_T) {
    let b_ref = c.beginCell();
    storeFn_T(cell.ref, b_ref);
    b.storeRef(b_ref.endCell());
}
function loadCellRef(s, loadFn_T) {
    let s_ref = s.loadRef().beginParse();
    return { ref: loadFn_T(s_ref) };
}
function storeTolkNullable(v, b, storeFn_T) {
    if (v === null) {
        b.storeUint(0, 1);
    }
    else {
        b.storeUint(1, 1);
        storeFn_T(v, b);
    }
}
function createDictionaryValue(loadFn_V, storeFn_V) {
    return {
        serialize(self, b) {
            storeFn_V(self, b);
        },
        parse(s) {
            const value = loadFn_V(s);
            s.endParse();
            return value;
        }
    };
}
// ————————————————————————————————————————————
//   parse get methods result from a TVM stack
//
class StackReader {
    tuple;
    constructor(tuple) {
        this.tuple = tuple;
    }
    static fromGetMethod(expectedN, getMethodResult) {
        let tuple = [];
        while (getMethodResult.stack.remaining) {
            tuple.push(getMethodResult.stack.pop());
        }
        if (tuple.length !== expectedN) {
            throw new Error(`expected ${expectedN} stack width, got ${tuple.length}`);
        }
        return new StackReader(tuple);
    }
    popExpecting(itemType) {
        const item = this.tuple.shift();
        if (item?.type === itemType) {
            return item;
        }
        throw new Error(`not '${itemType}' on a stack`);
    }
    popCellLike() {
        const item = this.tuple.shift();
        if (item && (item.type === 'cell' || item.type === 'slice' || item.type === 'builder')) {
            return item.cell;
        }
        throw new Error(`not cell/slice on a stack`);
    }
    readBigInt() {
        return this.popExpecting('int').value;
    }
    readBoolean() {
        return this.popExpecting('int').value !== 0n;
    }
    readCell() {
        return this.popCellLike();
    }
    readSlice() {
        return this.popCellLike().beginParse();
    }
    readNullable(readFn_T) {
        if (this.tuple[0].type === 'null') {
            this.tuple.shift();
            return null;
        }
        return readFn_T(this);
    }
    readCellRef(loadFn_T) {
        return { ref: loadFn_T(this.readCell().beginParse()) };
    }
}
export const NftItemInitAtDeployment = {
    create(args) {
        return {
            $: 'NftItemInitAtDeployment',
            isSoulbound: false,
            isRevealed: false,
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'NftItemInitAtDeployment',
            ownerAddress: s.loadAddress(),
            content: s.loadStringRefTail(),
            isSoulbound: s.loadBoolean(),
            isRevealed: s.loadBoolean(),
        };
    },
    store(self, b) {
        b.storeAddress(self.ownerAddress);
        b.storeStringRefTail(self.content);
        b.storeBit(self.isSoulbound);
        b.storeBit(self.isRevealed);
    },
    toCell(self) {
        return makeCellFrom(self, NftItemInitAtDeployment.store);
    }
};
export const RequestRevealContent = {
    PREFIX: 0xf000001e,
    create(args) {
        return {
            $: 'RequestRevealContent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000001e, 'RequestRevealContent');
        return {
            $: 'RequestRevealContent',
            queryId: s.loadUintBig(64),
            itemIndex: s.loadUintBig(256),
        };
    },
    store(self, b) {
        b.storeUint(0xf000001e, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.itemIndex, 256);
    },
    toCell(self) {
        return makeCellFrom(self, RequestRevealContent.store);
    }
};
export const UpdateContent = {
    PREFIX: 0xf000001d,
    create(args) {
        return {
            $: 'UpdateContent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000001d, 'UpdateContent');
        return {
            $: 'UpdateContent',
            queryId: s.loadUintBig(64),
            newContent: s.loadStringRefTail(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000001d, 32);
        b.storeUint(self.queryId, 64);
        b.storeStringRefTail(self.newContent);
    },
    toCell(self) {
        return makeCellFrom(self, UpdateContent.store);
    }
};
export const ConfigureMint = {
    PREFIX: 0xf0000001,
    create(args) {
        return {
            $: 'ConfigureMint',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000001, 'ConfigureMint');
        return {
            $: 'ConfigureMint',
            queryId: s.loadUintBig(64),
            mintPrice: s.loadCoins(),
            maxSupply: s.loadUintBig(32),
            maxPerWallet: s.loadUintBig(8),
            mintEnabled: s.loadBoolean(),
            mintStartTime: s.loadUintBig(32),
            mintEndTime: s.loadUintBig(32),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000001, 32);
        b.storeUint(self.queryId, 64);
        b.storeCoins(self.mintPrice);
        b.storeUint(self.maxSupply, 32);
        b.storeUint(self.maxPerWallet, 8);
        b.storeBit(self.mintEnabled);
        b.storeUint(self.mintStartTime, 32);
        b.storeUint(self.mintEndTime, 32);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureMint.store);
    }
};
export const ConfigureMintPhase = {
    PREFIX: 0xf0000008,
    create(args) {
        return {
            $: 'ConfigureMintPhase',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000008, 'ConfigureMintPhase');
        return {
            $: 'ConfigureMintPhase',
            queryId: s.loadUintBig(64),
            mintPhase: s.loadUintBig(8),
            whitelistPrice: s.loadCoins(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000008, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.mintPhase, 8);
        b.storeCoins(self.whitelistPrice);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureMintPhase.store);
    }
};
export const WhitelistAdd = {
    PREFIX: 0xf0000009,
    create(args) {
        return {
            $: 'WhitelistAdd',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000009, 'WhitelistAdd');
        return {
            $: 'WhitelistAdd',
            queryId: s.loadUintBig(64),
            account: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000009, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.account);
    },
    toCell(self) {
        return makeCellFrom(self, WhitelistAdd.store);
    }
};
export const PublicMint = {
    PREFIX: 0xf000001b,
    create(args) {
        return {
            $: 'PublicMint',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000001b, 'PublicMint');
        return {
            $: 'PublicMint',
            queryId: s.loadUintBig(64),
            quantity: s.loadUintBig(32),
        };
    },
    store(self, b) {
        b.storeUint(0xf000001b, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.quantity, 32);
    },
    toCell(self) {
        return makeCellFrom(self, PublicMint.store);
    }
};
export const NftMintedEvent = {
    PREFIX: 0xf000f000,
    create(args) {
        return {
            $: 'NftMintedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f000, 'NftMintedEvent');
        return {
            $: 'NftMintedEvent',
            buyer: s.loadAddress(),
            startIndex: s.loadUintBig(64),
            quantity: s.loadUintBig(32),
            totalPaid: s.loadCoins(),
            mintedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f000, 32);
        b.storeAddress(self.buyer);
        b.storeUint(self.startIndex, 64);
        b.storeUint(self.quantity, 32);
        b.storeCoins(self.totalPaid);
        b.storeUint(self.mintedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, NftMintedEvent.store);
    }
};
export const OwnerMint = {
    PREFIX: 0xf000000e,
    create(args) {
        return {
            $: 'OwnerMint',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000000e, 'OwnerMint');
        return {
            $: 'OwnerMint',
            queryId: s.loadUintBig(64),
            to: s.loadAddress(),
            quantity: s.loadUintBig(32),
        };
    },
    store(self, b) {
        b.storeUint(0xf000000e, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.to);
        b.storeUint(self.quantity, 32);
    },
    toCell(self) {
        return makeCellFrom(self, OwnerMint.store);
    }
};
export const ConfigureSoulbound = {
    PREFIX: 0xf000000d,
    create(args) {
        return {
            $: 'ConfigureSoulbound',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000000d, 'ConfigureSoulbound');
        return {
            $: 'ConfigureSoulbound',
            queryId: s.loadUintBig(64),
            soulbound: s.loadBoolean(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000000d, 32);
        b.storeUint(self.queryId, 64);
        b.storeBit(self.soulbound);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureSoulbound.store);
    }
};
export const EnableReveal = {
    PREFIX: 0xf0000004,
    create(args) {
        return {
            $: 'EnableReveal',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000004, 'EnableReveal');
        return {
            $: 'EnableReveal',
            queryId: s.loadUintBig(64),
            revealStartTime: s.loadUintBig(32),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000004, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.revealStartTime, 32);
    },
    toCell(self) {
        return makeCellFrom(self, EnableReveal.store);
    }
};
export const FreezeMetadata = {
    PREFIX: 0xf000000f,
    create(args) {
        return {
            $: 'FreezeMetadata',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000000f, 'FreezeMetadata');
        return {
            $: 'FreezeMetadata',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000000f, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, FreezeMetadata.store);
    }
};
export const ConfigureFreezePolicy = {
    PREFIX: 0xf0000018,
    create(args) {
        return {
            $: 'ConfigureFreezePolicy',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000018, 'ConfigureFreezePolicy');
        return {
            $: 'ConfigureFreezePolicy',
            queryId: s.loadUintBig(64),
            freezeRequiredBeforeMint: s.loadBoolean(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000018, 32);
        b.storeUint(self.queryId, 64);
        b.storeBit(self.freezeRequiredBeforeMint);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureFreezePolicy.store);
    }
};
export const ConfigureFeeSplit = {
    PREFIX: 0xf000001f,
    create(args) {
        return {
            $: 'ConfigureFeeSplit',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000001f, 'ConfigureFeeSplit');
        return {
            $: 'ConfigureFeeSplit',
            queryId: s.loadUintBig(64),
            count: s.loadUintBig(8),
            entries: c.Dictionary.load(c.Dictionary.Keys.BigUint(8), createDictionaryValue(FeeSplitEntry.fromSlice, FeeSplitEntry.store), s),
        };
    },
    store(self, b) {
        b.storeUint(0xf000001f, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.count, 8);
        b.storeDict(self.entries, c.Dictionary.Keys.BigUint(8), createDictionaryValue(FeeSplitEntry.fromSlice, FeeSplitEntry.store));
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureFeeSplit.store);
    }
};
export const FeeSplitConfiguredEvent = {
    PREFIX: 0xf000f01e,
    create(args) {
        return {
            $: 'FeeSplitConfiguredEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f01e, 'FeeSplitConfiguredEvent');
        return {
            $: 'FeeSplitConfiguredEvent',
            count: s.loadUintBig(8),
            totalBasisPoints: s.loadUintBig(16),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f01e, 32);
        b.storeUint(self.count, 8);
        b.storeUint(self.totalBasisPoints, 16);
    },
    toCell(self) {
        return makeCellFrom(self, FeeSplitConfiguredEvent.store);
    }
};
export const FeeSplitPaidEvent = {
    PREFIX: 0xf000f01f,
    create(args) {
        return {
            $: 'FeeSplitPaidEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f01f, 'FeeSplitPaidEvent');
        return {
            $: 'FeeSplitPaidEvent',
            recipient: s.loadAddress(),
            amount: s.loadCoins(),
            basisPoints: s.loadUintBig(16),
            mintRevenue: s.loadCoins(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f01f, 32);
        b.storeAddress(self.recipient);
        b.storeCoins(self.amount);
        b.storeUint(self.basisPoints, 16);
        b.storeCoins(self.mintRevenue);
    },
    toCell(self) {
        return makeCellFrom(self, FeeSplitPaidEvent.store);
    }
};
export const LockSupply = {
    PREFIX: 0xf0000010,
    create(args) {
        return {
            $: 'LockSupply',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000010, 'LockSupply');
        return {
            $: 'LockSupply',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000010, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, LockSupply.store);
    }
};
export const RevealEnabledEvent = {
    PREFIX: 0xf000f004,
    create(args) {
        return {
            $: 'RevealEnabledEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f004, 'RevealEnabledEvent');
        return {
            $: 'RevealEnabledEvent',
            revealStartTime: s.loadUintBig(32),
            enabledAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f004, 32);
        b.storeUint(self.revealStartTime, 32);
        b.storeUint(self.enabledAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RevealEnabledEvent.store);
    }
};
export const MetadataFrozenEvent = {
    PREFIX: 0xf000f00f,
    create(args) {
        return {
            $: 'MetadataFrozenEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f00f, 'MetadataFrozenEvent');
        return {
            $: 'MetadataFrozenEvent',
            frozenAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f00f, 32);
        b.storeUint(self.frozenAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, MetadataFrozenEvent.store);
    }
};
export const ChangeOwner = {
    PREFIX: 0xf0000011,
    create(args) {
        return {
            $: 'ChangeOwner',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000011, 'ChangeOwner');
        return {
            $: 'ChangeOwner',
            queryId: s.loadUintBig(64),
            newOwner: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000011, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.newOwner);
    },
    toCell(self) {
        return makeCellFrom(self, ChangeOwner.store);
    }
};
export const AcceptOwnership = {
    PREFIX: 0xf0000012,
    create(args) {
        return {
            $: 'AcceptOwnership',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000012, 'AcceptOwnership');
        return {
            $: 'AcceptOwnership',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000012, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, AcceptOwnership.store);
    }
};
export const BlacklistAdd = {
    PREFIX: 0xf000000b,
    create(args) {
        return {
            $: 'BlacklistAdd',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000000b, 'BlacklistAdd');
        return {
            $: 'BlacklistAdd',
            queryId: s.loadUintBig(64),
            account: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000000b, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.account);
    },
    toCell(self) {
        return makeCellFrom(self, BlacklistAdd.store);
    }
};
export const BlacklistRemove = {
    PREFIX: 0xf000000c,
    create(args) {
        return {
            $: 'BlacklistRemove',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000000c, 'BlacklistRemove');
        return {
            $: 'BlacklistRemove',
            queryId: s.loadUintBig(64),
            account: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000000c, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.account);
    },
    toCell(self) {
        return makeCellFrom(self, BlacklistRemove.store);
    }
};
export const WhitelistRemove = {
    PREFIX: 0xf000000a,
    create(args) {
        return {
            $: 'WhitelistRemove',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000000a, 'WhitelistRemove');
        return {
            $: 'WhitelistRemove',
            queryId: s.loadUintBig(64),
            account: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf000000a, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.account);
    },
    toCell(self) {
        return makeCellFrom(self, WhitelistRemove.store);
    }
};
export const ConfigureMinter = {
    PREFIX: 0xf0000014,
    create(args) {
        return {
            $: 'ConfigureMinter',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000014, 'ConfigureMinter');
        return {
            $: 'ConfigureMinter',
            queryId: s.loadUintBig(64),
            minter: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000014, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.minter);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureMinter.store);
    }
};
export const RemoveMinterSync = {
    PREFIX: 0xf0000015,
    create(args) {
        return {
            $: 'RemoveMinterSync',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000015, 'RemoveMinterSync');
        return {
            $: 'RemoveMinterSync',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000015, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RemoveMinterSync.store);
    }
};
export const ConfigureMinterRateLimit = {
    PREFIX: 0xf0000016,
    create(args) {
        return {
            $: 'ConfigureMinterRateLimit',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000016, 'ConfigureMinterRateLimit');
        return {
            $: 'ConfigureMinterRateLimit',
            queryId: s.loadUintBig(64),
            ratePerWindow: s.loadUintBig(32),
            windowSec: s.loadUintBig(32),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000016, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.ratePerWindow, 32);
        b.storeUint(self.windowSec, 32);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureMinterRateLimit.store);
    }
};
export const MinterMint = {
    PREFIX: 0xf0000017,
    create(args) {
        return {
            $: 'MinterMint',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000017, 'MinterMint');
        return {
            $: 'MinterMint',
            queryId: s.loadUintBig(64),
            to: s.loadAddress(),
            quantity: s.loadUintBig(32),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000017, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.to);
        b.storeUint(self.quantity, 32);
    },
    toCell(self) {
        return makeCellFrom(self, MinterMint.store);
    }
};
export const MinterMintWithContent = {
    PREFIX: 0xf0000021,
    create(args) {
        return {
            $: 'MinterMintWithContent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000021, 'MinterMintWithContent');
        return {
            $: 'MinterMintWithContent',
            queryId: s.loadUintBig(64),
            to: s.loadAddress(),
            individualContent: s.loadStringRefTail(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000021, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.to);
        b.storeStringRefTail(self.individualContent);
    },
    toCell(self) {
        return makeCellFrom(self, MinterMintWithContent.store);
    }
};
export const ConfigureRoyalty = {
    PREFIX: 0xf0000020,
    create(args) {
        return {
            $: 'ConfigureRoyalty',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000020, 'ConfigureRoyalty');
        return {
            $: 'ConfigureRoyalty',
            queryId: s.loadUintBig(64),
            numerator: s.loadUintBig(16),
            denominator: s.loadUintBig(16),
            royaltyAddress: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000020, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.numerator, 16);
        b.storeUint(self.denominator, 16);
        b.storeAddress(self.royaltyAddress);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureRoyalty.store);
    }
};
export const RoyaltyConfigChangedEvent = {
    PREFIX: 0xf000f020,
    create(args) {
        return {
            $: 'RoyaltyConfigChangedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f020, 'RoyaltyConfigChangedEvent');
        return {
            $: 'RoyaltyConfigChangedEvent',
            numerator: s.loadUintBig(16),
            denominator: s.loadUintBig(16),
            royaltyAddress: s.loadAddress(),
            changedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f020, 32);
        b.storeUint(self.numerator, 16);
        b.storeUint(self.denominator, 16);
        b.storeAddress(self.royaltyAddress);
        b.storeUint(self.changedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RoyaltyConfigChangedEvent.store);
    }
};
export const BlacklistChangedEvent = {
    PREFIX: 0xf000f021,
    create(args) {
        return {
            $: 'BlacklistChangedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f021, 'BlacklistChangedEvent');
        return {
            $: 'BlacklistChangedEvent',
            account: s.loadAddress(),
            added: s.loadBoolean(),
            changedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f021, 32);
        b.storeAddress(self.account);
        b.storeBit(self.added);
        b.storeUint(self.changedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, BlacklistChangedEvent.store);
    }
};
export const SoulboundConfiguredEvent = {
    PREFIX: 0xf000f022,
    create(args) {
        return {
            $: 'SoulboundConfiguredEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f022, 'SoulboundConfiguredEvent');
        return {
            $: 'SoulboundConfiguredEvent',
            soulbound: s.loadBoolean(),
            configuredAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f022, 32);
        b.storeBit(self.soulbound);
        b.storeUint(self.configuredAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, SoulboundConfiguredEvent.store);
    }
};
export const SupplyLockedEvent = {
    PREFIX: 0xf000f023,
    create(args) {
        return {
            $: 'SupplyLockedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f023, 'SupplyLockedEvent');
        return {
            $: 'SupplyLockedEvent',
            lockedSupply: s.loadUintBig(32),
            lockedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f023, 32);
        b.storeUint(self.lockedSupply, 32);
        b.storeUint(self.lockedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, SupplyLockedEvent.store);
    }
};
export const OwnershipRenouncedEvent = {
    PREFIX: 0xf000f024,
    create(args) {
        return {
            $: 'OwnershipRenouncedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f024, 'OwnershipRenouncedEvent');
        return {
            $: 'OwnershipRenouncedEvent',
            previousOwner: s.loadAddress(),
            renouncedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f024, 32);
        b.storeAddress(self.previousOwner);
        b.storeUint(self.renouncedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, OwnershipRenouncedEvent.store);
    }
};
export const WhitelistChangedEvent = {
    PREFIX: 0xf000f025,
    create(args) {
        return {
            $: 'WhitelistChangedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f025, 'WhitelistChangedEvent');
        return {
            $: 'WhitelistChangedEvent',
            account: s.loadAddress(),
            added: s.loadBoolean(),
            changedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f025, 32);
        b.storeAddress(self.account);
        b.storeBit(self.added);
        b.storeUint(self.changedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, WhitelistChangedEvent.store);
    }
};
export const MintPhaseChangedEvent = {
    PREFIX: 0xf000f026,
    create(args) {
        return {
            $: 'MintPhaseChangedEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f026, 'MintPhaseChangedEvent');
        return {
            $: 'MintPhaseChangedEvent',
            phase: s.loadUintBig(8),
            whitelistPrice: s.loadCoins(),
            changedAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f026, 32);
        b.storeUint(self.phase, 8);
        b.storeCoins(self.whitelistPrice);
        b.storeUint(self.changedAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, MintPhaseChangedEvent.store);
    }
};
export const MintConfiguredEvent = {
    PREFIX: 0xf000f027,
    create(args) {
        return {
            $: 'MintConfiguredEvent',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000f027, 'MintConfiguredEvent');
        return {
            $: 'MintConfiguredEvent',
            mintEnabled: s.loadBoolean(),
            mintPrice: s.loadCoins(),
            maxSupply: s.loadUintBig(32),
            maxPerWallet: s.loadUintBig(8),
            mintStartTime: s.loadUintBig(32),
            mintEndTime: s.loadUintBig(32),
            configuredAt: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf000f027, 32);
        b.storeBit(self.mintEnabled);
        b.storeCoins(self.mintPrice);
        b.storeUint(self.maxSupply, 32);
        b.storeUint(self.maxPerWallet, 8);
        b.storeUint(self.mintStartTime, 32);
        b.storeUint(self.mintEndTime, 32);
        b.storeUint(self.configuredAt, 64);
    },
    toCell(self) {
        return makeCellFrom(self, MintConfiguredEvent.store);
    }
};
export const Withdraw = {
    PREFIX: 0xf0000006,
    create(args) {
        return {
            $: 'Withdraw',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000006, 'Withdraw');
        return {
            $: 'Withdraw',
            queryId: s.loadUintBig(64),
            to: s.loadAddress(),
            amount: s.loadCoins(),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000006, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.to);
        b.storeCoins(self.amount);
    },
    toCell(self) {
        return makeCellFrom(self, Withdraw.store);
    }
};
export const SweepExcess = {
    PREFIX: 0xf0000007,
    create(args) {
        return {
            $: 'SweepExcess',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000007, 'SweepExcess');
        return {
            $: 'SweepExcess',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000007, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, SweepExcess.store);
    }
};
export const ConfigureShuffleCommitment = {
    PREFIX: 0xf0000019,
    create(args) {
        return {
            $: 'ConfigureShuffleCommitment',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000019, 'ConfigureShuffleCommitment');
        return {
            $: 'ConfigureShuffleCommitment',
            queryId: s.loadUintBig(64),
            commitment: s.loadUintBig(256),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000019, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.commitment, 256);
    },
    toCell(self) {
        return makeCellFrom(self, ConfigureShuffleCommitment.store);
    }
};
export const UnlockShuffle = {
    PREFIX: 0xf000001a,
    create(args) {
        return {
            $: 'UnlockShuffle',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf000001a, 'UnlockShuffle');
        return {
            $: 'UnlockShuffle',
            queryId: s.loadUintBig(64),
            seed: s.loadUintBig(256),
        };
    },
    store(self, b) {
        b.storeUint(0xf000001a, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.seed, 256);
    },
    toCell(self) {
        return makeCellFrom(self, UnlockShuffle.store);
    }
};
export const RenounceOwnership = {
    PREFIX: 0xf0000013,
    create(args) {
        return {
            $: 'RenounceOwnership',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xf0000013, 'RenounceOwnership');
        return {
            $: 'RenounceOwnership',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xf0000013, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RenounceOwnership.store);
    }
};
export const RequestRoyaltyParams = {
    PREFIX: 0x693d3950,
    create(args) {
        return {
            $: 'RequestRoyaltyParams',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0x693d3950, 'RequestRoyaltyParams');
        return {
            $: 'RequestRoyaltyParams',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0x693d3950, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, RequestRoyaltyParams.store);
    }
};
export const ResponseRoyaltyParams = {
    PREFIX: 0xa8cb00ad,
    create(args) {
        return {
            $: 'ResponseRoyaltyParams',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xa8cb00ad, 'ResponseRoyaltyParams');
        return {
            $: 'ResponseRoyaltyParams',
            queryId: s.loadUintBig(64),
            royaltyParams: RoyaltyParams.fromSlice(s),
        };
    },
    store(self, b) {
        b.storeUint(0xa8cb00ad, 32);
        b.storeUint(self.queryId, 64);
        RoyaltyParams.store(self.royaltyParams, b);
    },
    toCell(self) {
        return makeCellFrom(self, ResponseRoyaltyParams.store);
    }
};
export const DeployNft = {
    PREFIX: 0x00000001,
    create(args) {
        return {
            $: 'DeployNft',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0x00000001, 'DeployNft');
        return {
            $: 'DeployNft',
            queryId: s.loadUintBig(64),
            itemIndex: s.loadUintBig(64),
            attachTonAmount: s.loadCoins(),
            initParams: loadCellRef(s, NftItemInitAtDeployment.fromSlice),
        };
    },
    store(self, b) {
        b.storeUint(0x00000001, 32);
        b.storeUint(self.queryId, 64);
        b.storeUint(self.itemIndex, 64);
        b.storeCoins(self.attachTonAmount);
        storeCellRef(self.initParams, b, NftItemInitAtDeployment.store);
    },
    toCell(self) {
        return makeCellFrom(self, DeployNft.store);
    }
};
export const BatchDeployNfts = {
    PREFIX: 0x00000002,
    create(args) {
        return {
            $: 'BatchDeployNfts',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0x00000002, 'BatchDeployNfts');
        return {
            $: 'BatchDeployNfts',
            queryId: s.loadUintBig(64),
            deployList: c.Dictionary.load(c.Dictionary.Keys.BigUint(64), createDictionaryValue(BatchDeployDictItem.fromSlice, BatchDeployDictItem.store), s),
        };
    },
    store(self, b) {
        b.storeUint(0x00000002, 32);
        b.storeUint(self.queryId, 64);
        b.storeDict(self.deployList, c.Dictionary.Keys.BigUint(64), createDictionaryValue(BatchDeployDictItem.fromSlice, BatchDeployDictItem.store));
    },
    toCell(self) {
        return makeCellFrom(self, BatchDeployNfts.store);
    }
};
export const BatchDeployDictItem = {
    create(args) {
        return {
            $: 'BatchDeployDictItem',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'BatchDeployDictItem',
            attachTonAmount: s.loadCoins(),
            initParams: loadCellRef(s, NftItemInitAtDeployment.fromSlice),
        };
    },
    store(self, b) {
        b.storeCoins(self.attachTonAmount);
        storeCellRef(self.initParams, b, NftItemInitAtDeployment.store);
    },
    toCell(self) {
        return makeCellFrom(self, BatchDeployDictItem.store);
    }
};
export const ChangeCollectionAdmin = {
    PREFIX: 0x00000003,
    create(args) {
        return {
            $: 'ChangeCollectionAdmin',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0x00000003, 'ChangeCollectionAdmin');
        return {
            $: 'ChangeCollectionAdmin',
            queryId: s.loadUintBig(64),
            newAdminAddress: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(0x00000003, 32);
        b.storeUint(self.queryId, 64);
        b.storeAddress(self.newAdminAddress);
    },
    toCell(self) {
        return makeCellFrom(self, ChangeCollectionAdmin.store);
    }
};
export const ReturnExcessesBack = {
    PREFIX: 0xd53276db,
    create(args) {
        return {
            $: 'ReturnExcessesBack',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix32(s, 0xd53276db, 'ReturnExcessesBack');
        return {
            $: 'ReturnExcessesBack',
            queryId: s.loadUintBig(64),
        };
    },
    store(self, b) {
        b.storeUint(0xd53276db, 32);
        b.storeUint(self.queryId, 64);
    },
    toCell(self) {
        return makeCellFrom(self, ReturnExcessesBack.store);
    }
};
export const RoyaltyParams = {
    create(args) {
        return {
            $: 'RoyaltyParams',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'RoyaltyParams',
            numerator: s.loadUintBig(16),
            denominator: s.loadUintBig(16),
            royaltyAddress: s.loadAddress(),
        };
    },
    store(self, b) {
        b.storeUint(self.numerator, 16);
        b.storeUint(self.denominator, 16);
        b.storeAddress(self.royaltyAddress);
    },
    toCell(self) {
        return makeCellFrom(self, RoyaltyParams.store);
    }
};
export const MintExtras = {
    create(args) {
        return {
            $: 'MintExtras',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'MintExtras',
            commitment: s.loadUintBig(256),
            seed: s.loadUintBig(256),
            unlocked: s.loadBoolean(),
            feeSplitCount: s.loadUintBig(8),
            feeSplitTotalBp: s.loadUintBig(16),
            feeSplits: c.Dictionary.load(c.Dictionary.Keys.BigUint(8), createDictionaryValue(FeeSplitEntry.fromSlice, FeeSplitEntry.store), s),
        };
    },
    store(self, b) {
        b.storeUint(self.commitment, 256);
        b.storeUint(self.seed, 256);
        b.storeBit(self.unlocked);
        b.storeUint(self.feeSplitCount, 8);
        b.storeUint(self.feeSplitTotalBp, 16);
        b.storeDict(self.feeSplits, c.Dictionary.Keys.BigUint(8), createDictionaryValue(FeeSplitEntry.fromSlice, FeeSplitEntry.store));
    },
    toCell(self) {
        return makeCellFrom(self, MintExtras.store);
    }
};
export const FeeSplitEntry = {
    create(args) {
        return {
            $: 'FeeSplitEntry',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'FeeSplitEntry',
            recipient: s.loadAddress(),
            basisPoints: s.loadUintBig(16),
        };
    },
    store(self, b) {
        b.storeAddress(self.recipient);
        b.storeUint(self.basisPoints, 16);
    },
    toCell(self) {
        return makeCellFrom(self, FeeSplitEntry.store);
    }
};
export const MintState = {
    create(args) {
        return {
            $: 'MintState',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'MintState',
            mintPrice: s.loadCoins(),
            maxSupply: s.loadUintBig(32),
            maxPerWallet: s.loadUintBig(8),
            mintEnabled: s.loadBoolean(),
            mintPhase: s.loadUintBig(8),
            whitelistPrice: s.loadCoins(),
            mintStartTime: s.loadUintBig(32),
            mintEndTime: s.loadUintBig(32),
            soulbound: s.loadBoolean(),
            revealEnabled: s.loadBoolean(),
            revealStartTime: s.loadUintBig(32),
            metadataFrozen: s.loadBoolean(),
            supplyLocked: s.loadBoolean(),
            freezeRequiredBeforeMint: s.loadBoolean(),
            frozenAt: s.loadUintBig(32),
            minterRatePerWindow: s.loadUintBig(32),
            minterWindowSec: s.loadUintBig(32),
            minterMintedInWindow: s.loadUintBig(32),
            minterWindowStart: s.loadUintBig(32),
            serverMinted: s.loadUintBig(32),
            extras: loadCellRef(s, MintExtras.fromSlice),
            whitelist: c.Dictionary.load(c.Dictionary.Keys.Address(), c.Dictionary.Values.Bool(), s),
            blacklist: c.Dictionary.load(c.Dictionary.Keys.Address(), c.Dictionary.Values.Bool(), s),
            mintedPerWallet: c.Dictionary.load(c.Dictionary.Keys.Address(), c.Dictionary.Values.BigUint(32), s),
        };
    },
    store(self, b) {
        b.storeCoins(self.mintPrice);
        b.storeUint(self.maxSupply, 32);
        b.storeUint(self.maxPerWallet, 8);
        b.storeBit(self.mintEnabled);
        b.storeUint(self.mintPhase, 8);
        b.storeCoins(self.whitelistPrice);
        b.storeUint(self.mintStartTime, 32);
        b.storeUint(self.mintEndTime, 32);
        b.storeBit(self.soulbound);
        b.storeBit(self.revealEnabled);
        b.storeUint(self.revealStartTime, 32);
        b.storeBit(self.metadataFrozen);
        b.storeBit(self.supplyLocked);
        b.storeBit(self.freezeRequiredBeforeMint);
        b.storeUint(self.frozenAt, 32);
        b.storeUint(self.minterRatePerWindow, 32);
        b.storeUint(self.minterWindowSec, 32);
        b.storeUint(self.minterMintedInWindow, 32);
        b.storeUint(self.minterWindowStart, 32);
        b.storeUint(self.serverMinted, 32);
        storeCellRef(self.extras, b, MintExtras.store);
        b.storeDict(self.whitelist, c.Dictionary.Keys.Address(), c.Dictionary.Values.Bool());
        b.storeDict(self.blacklist, c.Dictionary.Keys.Address(), c.Dictionary.Values.Bool());
        b.storeDict(self.mintedPerWallet, c.Dictionary.Keys.Address(), c.Dictionary.Values.BigUint(32));
    },
    toCell(self) {
        return makeCellFrom(self, MintState.store);
    }
};
export const NftCollectionStorage = {
    create(args) {
        return {
            $: 'NftCollectionStorage',
            pendingOwner: null,
            minter: null,
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'NftCollectionStorage',
            adminAddress: s.loadAddress(),
            nextItemIndex: s.loadUintBig(64),
            content: loadCellRef(s, CollectionContent.fromSlice),
            nftItemCode: s.loadRef(),
            royaltyParams: loadCellRef(s, RoyaltyParams.fromSlice),
            mint: loadCellRef(s, MintState.fromSlice),
            pendingOwner: s.loadMaybeAddress(),
            minter: s.loadMaybeAddress(),
        };
    },
    store(self, b) {
        b.storeAddress(self.adminAddress);
        b.storeUint(self.nextItemIndex, 64);
        storeCellRef(self.content, b, CollectionContent.store);
        b.storeRef(self.nftItemCode);
        storeCellRef(self.royaltyParams, b, RoyaltyParams.store);
        storeCellRef(self.mint, b, MintState.store);
        b.storeAddress(self.pendingOwner);
        b.storeAddress(self.minter);
    },
    toCell(self) {
        return makeCellFrom(self, NftCollectionStorage.store);
    }
};
export const MintConfigReply = {
    create(args) {
        return {
            $: 'MintConfigReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'MintConfigReply' from cell, because 'MintConfigReply.maxSupply' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'MintConfigReply' to cell, because 'self.maxSupply' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, MintConfigReply.store);
    }
};
export const ContentLifecycleReply = {
    create(args) {
        return {
            $: 'ContentLifecycleReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'ContentLifecycleReply' from cell, because 'ContentLifecycleReply.revealStartTime' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'ContentLifecycleReply' to cell, because 'self.revealStartTime' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, ContentLifecycleReply.store);
    }
};
export const FreezePolicyReply = {
    create(args) {
        return {
            $: 'FreezePolicyReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'FreezePolicyReply' from cell, because 'FreezePolicyReply.frozenAt' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'FreezePolicyReply' to cell, because 'self.frozenAt' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, FreezePolicyReply.store);
    }
};
export const MinterRateLimitReply = {
    create(args) {
        return {
            $: 'MinterRateLimitReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'MinterRateLimitReply' from cell, because 'MinterRateLimitReply.ratePerWindow' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'MinterRateLimitReply' to cell, because 'self.ratePerWindow' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, MinterRateLimitReply.store);
    }
};
export const ShuffleConfigReply = {
    create(args) {
        return {
            $: 'ShuffleConfigReply',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'ShuffleConfigReply',
            commitment: s.loadUintBig(256),
            seed: s.loadUintBig(256),
            unlocked: s.loadBoolean(),
        };
    },
    store(self, b) {
        b.storeUint(self.commitment, 256);
        b.storeUint(self.seed, 256);
        b.storeBit(self.unlocked);
    },
    toCell(self) {
        return makeCellFrom(self, ShuffleConfigReply.store);
    }
};
export const FeeSplitConfigReply = {
    create(args) {
        return {
            $: 'FeeSplitConfigReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'FeeSplitConfigReply' from cell, because 'FeeSplitConfigReply.count' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'FeeSplitConfigReply' to cell, because 'self.count' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, FeeSplitConfigReply.store);
    }
};
export const CollectionContent = {
    create(args) {
        return {
            $: 'CollectionContent',
            ...args
        };
    },
    fromSlice(s) {
        return {
            $: 'CollectionContent',
            collectionMetadata: s.loadRef(),
            commonContent: s.loadStringRefTail(),
        };
    },
    store(self, b) {
        b.storeRef(self.collectionMetadata);
        b.storeStringRefTail(self.commonContent);
    },
    toCell(self) {
        return makeCellFrom(self, CollectionContent.store);
    }
};
export const CollectionDataReply = {
    create(args) {
        return {
            $: 'CollectionDataReply',
            ...args
        };
    },
    fromSlice(s) {
        throw new Error(`Can't unpack 'CollectionDataReply' from cell, because 'CollectionDataReply.nextItemIndex' is 'int' (not int32/uint64/etc.)`);
    },
    store(self, b) {
        throw new Error(`Can't pack 'CollectionDataReply' to cell, because 'self.nextItemIndex' is 'int' (not int32/uint64/etc.)`);
    },
    toCell(self) {
        return makeCellFrom(self, CollectionDataReply.store);
    }
};
export const OffchainMetadataReply = {
    PREFIX: 0x01,
    create(args) {
        return {
            $: 'OffchainMetadataReply',
            ...args
        };
    },
    fromSlice(s) {
        loadAndCheckPrefix(s, 0x01, 8, 'OffchainMetadataReply');
        return {
            $: 'OffchainMetadataReply',
            string: s.loadStringRefTail(),
        };
    },
    store(self, b) {
        b.storeUint(0x01, 8);
        b.storeStringRefTail(self.string);
    },
    toCell(self) {
        return makeCellFrom(self, OffchainMetadataReply.store);
    }
};
function calculateDeployedAddress(code, data, options) {
    const stateInitCell = beginCell().store(c.storeStateInit({
        code,
        data,
        splitDepth: options.toShard?.fixedPrefixLength,
        special: null,
        libraries: null,
    })).endCell();
    let addrHash = stateInitCell.hash();
    if (options.toShard) {
        const shardDepth = options.toShard.fixedPrefixLength;
        addrHash = beginCell()
            .storeBits(new c.BitString(options.toShard.closeTo.hash, 0, shardDepth))
            .storeBits(new c.BitString(stateInitCell.hash(), shardDepth, 256 - shardDepth))
            .endCell()
            .beginParse().loadBuffer(32);
    }
    return new c.Address(options.workchain ?? 0, addrHash);
}
export class NftCollection {
    static CodeCell = c.Cell.fromBase64('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');
    static Errors = {
        'Errors.InvalidWorkchain': 333,
        'Errors.BatchLimitExceeded': 399,
        'Errors.NotFromAdmin': 401,
        'Errors.InvalidItemIndex': 402,
        'Errors.MintDisabled': 420,
        'Errors.MintNotStarted': 421,
        'Errors.MintEnded': 422,
        'Errors.Blacklisted': 423,
        'Errors.MintPhaseClosed': 424,
        'Errors.NotWhitelisted': 425,
        'Errors.InvalidQuantity': 426,
        'Errors.SoldOut': 427,
        'Errors.WalletLimit': 428,
        'Errors.InsufficientPayment': 429,
        'Errors.InvalidMintConfig': 430,
        'Errors.NotFromMinter': 440,
        'Errors.MintersNotEmpty': 445,
        'Errors.SupplyLocked': 450,
        'Errors.RevealNotEnabled': 451,
        'Errors.RevealNotStarted': 452,
        'Errors.NotValidNft': 453,
        'Errors.RevealAlreadyEnabled': 454,
        'Errors.SoulboundAfterMint': 455,
        'Errors.ZeroMintRecipient': 456,
        'Errors.NoPendingOwner': 457,
        'Errors.NotPendingOwner': 458,
        'Errors.MinterNotConfigured': 459,
        'Errors.RateLimited': 460,
        'Errors.InvalidAmount': 461,
        'Errors.MinBalance': 462,
        'Errors.ShuffleAfterMint': 463,
        'Errors.ShuffleCommitmentSet': 464,
        'Errors.InvalidCommitment': 465,
        'Errors.CommitmentNotSet': 466,
        'Errors.CommitmentMismatch': 467,
        'Errors.SeedMismatch': 468,
        'Errors.MetadataNotFrozen': 469,
        'Errors.MetadataAlreadyFrozen': 470,
        'Errors.FreezePolicyAfterMint': 471,
        'Errors.TooManySplits': 472,
        'Errors.ZeroBasisPoints': 473,
        'Errors.BpsOver100Pct': 474,
        'Errors.FeeSplitAfterMint': 475,
        'Errors.MissingSplitEntry': 476,
        'Errors.InvalidDenominator': 477,
        'Errors.InvalidNumerator': 478,
        'Errors.RoyaltyCeilingExceeded': 479,
        'Errors.InvalidRoyaltyDestination': 480,
        'Errors.RateLimitTooHigh': 481,
        'Errors.InvalidRateLimitWindow': 482,
    };
    address;
    init;
    constructor(address, init) {
        this.address = address;
        this.init = init;
    }
    static fromAddress(address) {
        return new NftCollection(address);
    }
    static fromStorage(emptyStorage, deployedOptions) {
        const initialState = {
            code: deployedOptions?.overrideContractCode ?? NftCollection.CodeCell,
            data: NftCollectionStorage.toCell(NftCollectionStorage.create(emptyStorage)),
        };
        const address = calculateDeployedAddress(initialState.code, initialState.data, deployedOptions ?? {});
        return new NftCollection(address, initialState);
    }
    static createCellOfRequestRoyaltyParams(body) {
        return RequestRoyaltyParams.toCell(RequestRoyaltyParams.create(body));
    }
    static createCellOfDeployNft(body) {
        return DeployNft.toCell(DeployNft.create(body));
    }
    static createCellOfBatchDeployNfts(body) {
        return BatchDeployNfts.toCell(BatchDeployNfts.create(body));
    }
    static createCellOfChangeCollectionAdmin(body) {
        return ChangeCollectionAdmin.toCell(ChangeCollectionAdmin.create(body));
    }
    static createCellOfConfigureMint(body) {
        return ConfigureMint.toCell(ConfigureMint.create(body));
    }
    static createCellOfConfigureMintPhase(body) {
        return ConfigureMintPhase.toCell(ConfigureMintPhase.create(body));
    }
    static createCellOfWhitelistAdd(body) {
        return WhitelistAdd.toCell(WhitelistAdd.create(body));
    }
    static createCellOfPublicMint(body) {
        return PublicMint.toCell(PublicMint.create(body));
    }
    static createCellOfOwnerMint(body) {
        return OwnerMint.toCell(OwnerMint.create(body));
    }
    static createCellOfConfigureSoulbound(body) {
        return ConfigureSoulbound.toCell(ConfigureSoulbound.create(body));
    }
    static createCellOfEnableReveal(body) {
        return EnableReveal.toCell(EnableReveal.create(body));
    }
    static createCellOfFreezeMetadata(body) {
        return FreezeMetadata.toCell(FreezeMetadata.create(body));
    }
    static createCellOfConfigureFreezePolicy(body) {
        return ConfigureFreezePolicy.toCell(ConfigureFreezePolicy.create(body));
    }
    static createCellOfLockSupply(body) {
        return LockSupply.toCell(LockSupply.create(body));
    }
    static createCellOfRequestRevealContent(body) {
        return RequestRevealContent.toCell(RequestRevealContent.create(body));
    }
    static createCellOfChangeOwner(body) {
        return ChangeOwner.toCell(ChangeOwner.create(body));
    }
    static createCellOfAcceptOwnership(body) {
        return AcceptOwnership.toCell(AcceptOwnership.create(body));
    }
    static createCellOfRenounceOwnership(body) {
        return RenounceOwnership.toCell(RenounceOwnership.create(body));
    }
    static createCellOfBlacklistAdd(body) {
        return BlacklistAdd.toCell(BlacklistAdd.create(body));
    }
    static createCellOfBlacklistRemove(body) {
        return BlacklistRemove.toCell(BlacklistRemove.create(body));
    }
    static createCellOfWhitelistRemove(body) {
        return WhitelistRemove.toCell(WhitelistRemove.create(body));
    }
    static createCellOfConfigureMinter(body) {
        return ConfigureMinter.toCell(ConfigureMinter.create(body));
    }
    static createCellOfRemoveMinterSync(body) {
        return RemoveMinterSync.toCell(RemoveMinterSync.create(body));
    }
    static createCellOfConfigureMinterRateLimit(body) {
        return ConfigureMinterRateLimit.toCell(ConfigureMinterRateLimit.create(body));
    }
    static createCellOfMinterMint(body) {
        return MinterMint.toCell(MinterMint.create(body));
    }
    static createCellOfMinterMintWithContent(body) {
        return MinterMintWithContent.toCell(MinterMintWithContent.create(body));
    }
    static createCellOfWithdraw(body) {
        return Withdraw.toCell(Withdraw.create(body));
    }
    static createCellOfSweepExcess(body) {
        return SweepExcess.toCell(SweepExcess.create(body));
    }
    static createCellOfConfigureShuffleCommitment(body) {
        return ConfigureShuffleCommitment.toCell(ConfigureShuffleCommitment.create(body));
    }
    static createCellOfUnlockShuffle(body) {
        return UnlockShuffle.toCell(UnlockShuffle.create(body));
    }
    static createCellOfConfigureFeeSplit(body) {
        return ConfigureFeeSplit.toCell(ConfigureFeeSplit.create(body));
    }
    static createCellOfConfigureRoyalty(body) {
        return ConfigureRoyalty.toCell(ConfigureRoyalty.create(body));
    }
    async sendDeploy(provider, via, msgValue, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: c.Cell.EMPTY,
            ...extraOptions
        });
    }
    async sendRequestRoyaltyParams(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RequestRoyaltyParams.toCell(RequestRoyaltyParams.create(body)),
            ...extraOptions
        });
    }
    async sendDeployNft(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: DeployNft.toCell(DeployNft.create(body)),
            ...extraOptions
        });
    }
    async sendBatchDeployNfts(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: BatchDeployNfts.toCell(BatchDeployNfts.create(body)),
            ...extraOptions
        });
    }
    async sendChangeCollectionAdmin(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ChangeCollectionAdmin.toCell(ChangeCollectionAdmin.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureMint(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureMint.toCell(ConfigureMint.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureMintPhase(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureMintPhase.toCell(ConfigureMintPhase.create(body)),
            ...extraOptions
        });
    }
    async sendWhitelistAdd(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: WhitelistAdd.toCell(WhitelistAdd.create(body)),
            ...extraOptions
        });
    }
    async sendPublicMint(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: PublicMint.toCell(PublicMint.create(body)),
            ...extraOptions
        });
    }
    async sendOwnerMint(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: OwnerMint.toCell(OwnerMint.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureSoulbound(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureSoulbound.toCell(ConfigureSoulbound.create(body)),
            ...extraOptions
        });
    }
    async sendEnableReveal(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: EnableReveal.toCell(EnableReveal.create(body)),
            ...extraOptions
        });
    }
    async sendFreezeMetadata(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: FreezeMetadata.toCell(FreezeMetadata.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureFreezePolicy(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureFreezePolicy.toCell(ConfigureFreezePolicy.create(body)),
            ...extraOptions
        });
    }
    async sendLockSupply(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: LockSupply.toCell(LockSupply.create(body)),
            ...extraOptions
        });
    }
    async sendRequestRevealContent(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RequestRevealContent.toCell(RequestRevealContent.create(body)),
            ...extraOptions
        });
    }
    async sendChangeOwner(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ChangeOwner.toCell(ChangeOwner.create(body)),
            ...extraOptions
        });
    }
    async sendAcceptOwnership(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: AcceptOwnership.toCell(AcceptOwnership.create(body)),
            ...extraOptions
        });
    }
    async sendRenounceOwnership(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RenounceOwnership.toCell(RenounceOwnership.create(body)),
            ...extraOptions
        });
    }
    async sendBlacklistAdd(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: BlacklistAdd.toCell(BlacklistAdd.create(body)),
            ...extraOptions
        });
    }
    async sendBlacklistRemove(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: BlacklistRemove.toCell(BlacklistRemove.create(body)),
            ...extraOptions
        });
    }
    async sendWhitelistRemove(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: WhitelistRemove.toCell(WhitelistRemove.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureMinter(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureMinter.toCell(ConfigureMinter.create(body)),
            ...extraOptions
        });
    }
    async sendRemoveMinterSync(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: RemoveMinterSync.toCell(RemoveMinterSync.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureMinterRateLimit(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureMinterRateLimit.toCell(ConfigureMinterRateLimit.create(body)),
            ...extraOptions
        });
    }
    async sendMinterMint(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: MinterMint.toCell(MinterMint.create(body)),
            ...extraOptions
        });
    }
    async sendMinterMintWithContent(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: MinterMintWithContent.toCell(MinterMintWithContent.create(body)),
            ...extraOptions
        });
    }
    async sendWithdraw(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: Withdraw.toCell(Withdraw.create(body)),
            ...extraOptions
        });
    }
    async sendSweepExcess(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: SweepExcess.toCell(SweepExcess.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureShuffleCommitment(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureShuffleCommitment.toCell(ConfigureShuffleCommitment.create(body)),
            ...extraOptions
        });
    }
    async sendUnlockShuffle(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: UnlockShuffle.toCell(UnlockShuffle.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureFeeSplit(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureFeeSplit.toCell(ConfigureFeeSplit.create(body)),
            ...extraOptions
        });
    }
    async sendConfigureRoyalty(provider, via, msgValue, body, extraOptions) {
        return provider.internal(via, {
            value: msgValue,
            body: ConfigureRoyalty.toCell(ConfigureRoyalty.create(body)),
            ...extraOptions
        });
    }
    async getCollectionData(provider) {
        const r = StackReader.fromGetMethod(3, await provider.get('get_collection_data', []));
        return ({
            $: 'CollectionDataReply',
            nextItemIndex: r.readBigInt(),
            collectionMetadata: r.readCell(),
            adminAddress: r.readSlice().loadAddress(),
        });
    }
    async getNftAddressByIndex(provider, itemIndex) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_nft_address_by_index', [
            { type: 'int', value: itemIndex },
        ]));
        return r.readSlice().loadAddress();
    }
    async getRoyaltyParams(provider) {
        const r = StackReader.fromGetMethod(3, await provider.get('royalty_params', []));
        return ({
            $: 'RoyaltyParams',
            numerator: r.readBigInt(),
            denominator: r.readBigInt(),
            royaltyAddress: r.readSlice().loadAddress(),
        });
    }
    async getNftContent(provider, _itemIndex, individualNftContent) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_nft_content', [
            { type: 'int', value: _itemIndex },
            { type: 'cell', cell: beginCell().storeStringTail(individualNftContent).endCell() },
        ]));
        return r.readCellRef(OffchainMetadataReply.fromSlice);
    }
    async getSupportsInterface(provider, interfaceId) {
        const r = StackReader.fromGetMethod(1, await provider.get('supports_interface', [
            { type: 'int', value: interfaceId },
        ]));
        return r.readBoolean();
    }
    async getAbiVersion(provider) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_abi_version', []));
        return r.readBigInt();
    }
    async getMintConfig(provider) {
        const r = StackReader.fromGetMethod(7, await provider.get('get_mint_config', []));
        return ({
            $: 'MintConfigReply',
            mintPrice: r.readBigInt(),
            maxSupply: r.readBigInt(),
            maxPerWallet: r.readBigInt(),
            mintEnabled: r.readBoolean(),
            mintPhase: r.readBigInt(),
            whitelistPrice: r.readBigInt(),
            totalMinted: r.readBigInt(),
        });
    }
    async getMinter(provider) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_minter', []));
        return r.readNullable((r) => r.readSlice().loadAddress());
    }
    async getMinterRateLimit(provider) {
        const r = StackReader.fromGetMethod(5, await provider.get('get_minter_rate_limit', []));
        return ({
            $: 'MinterRateLimitReply',
            ratePerWindow: r.readBigInt(),
            windowSec: r.readBigInt(),
            mintedInWindow: r.readBigInt(),
            windowStart: r.readBigInt(),
            serverMinted: r.readBigInt(),
        });
    }
    async getShuffleConfig(provider) {
        const r = StackReader.fromGetMethod(3, await provider.get('get_shuffle_config', []));
        return ({
            $: 'ShuffleConfigReply',
            commitment: r.readBigInt(),
            seed: r.readBigInt(),
            unlocked: r.readBoolean(),
        });
    }
    async getFeeSplit(provider) {
        const r = StackReader.fromGetMethod(2, await provider.get('get_fee_split', []));
        return ({
            $: 'FeeSplitConfigReply',
            count: r.readBigInt(),
            totalBasisPoints: r.readBigInt(),
        });
    }
    async getFeeSplitEntry(provider, index) {
        const r = StackReader.fromGetMethod(2, await provider.get('get_fee_split_entry', [
            { type: 'int', value: index },
        ]));
        return ({
            $: 'FeeSplitEntry',
            recipient: r.readSlice().loadAddress(),
            basisPoints: r.readBigInt(),
        });
    }
    async getIsBlacklisted(provider, account) {
        const r = StackReader.fromGetMethod(1, await provider.get('is_blacklisted', [
            { type: 'slice', cell: makeCellFrom(account, (v, b) => b.storeAddress(v)) },
        ]));
        return r.readBoolean();
    }
    async getIsWhitelisted(provider, account) {
        const r = StackReader.fromGetMethod(1, await provider.get('is_whitelisted', [
            { type: 'slice', cell: makeCellFrom(account, (v, b) => b.storeAddress(v)) },
        ]));
        return r.readBoolean();
    }
    async getContentLifecycle(provider) {
        const r = StackReader.fromGetMethod(5, await provider.get('get_content_lifecycle', []));
        return ({
            $: 'ContentLifecycleReply',
            soulbound: r.readBoolean(),
            revealEnabled: r.readBoolean(),
            revealStartTime: r.readBigInt(),
            metadataFrozen: r.readBoolean(),
            supplyLocked: r.readBoolean(),
        });
    }
    async getFreezePolicy(provider) {
        const r = StackReader.fromGetMethod(3, await provider.get('get_freeze_policy', []));
        return ({
            $: 'FreezePolicyReply',
            freezeRequiredBeforeMint: r.readBoolean(),
            metadataFrozen: r.readBoolean(),
            frozenAt: r.readBigInt(),
        });
    }
    async getMintedByWallet(provider, wallet) {
        const r = StackReader.fromGetMethod(1, await provider.get('get_minted_by_wallet', [
            { type: 'slice', cell: makeCellFrom(wallet, (v, b) => b.storeAddress(v)) },
        ]));
        return r.readBigInt();
    }
}
